// @ts-nocheck
import kkmapgl from '@/assets/sdk/kkmap-gl.es';
import WaterNormals from '../../../../imgs/waternormals.jpg';
import { getAssetBaseUrl, keepZeroOrLine } from '@/utils/utils';
import markerPng from '../../../../imgs/marker.png';
import areaMarkerPng from '../../../../imgs/area-marker.png';
import center_card_bg from '../../../../imgs/center-card-bg.png';
import icon_cap from '../../../../imgs/icon-cap.png';

import IconCapacityPng from '../../../../imgs/icon-capacity@2x.png';
import IconMonitorPng from '../../../../imgs/icon-monitor@2x.png';
import IconStationPng from '../../../../imgs/icon-station@2x.png';

import html2canvas from 'html2canvas';
import { keepTwoOrLine, keepPercentOrLine, keepZeroPercentOrLine } from '@/utils/utils';
import alarmPng from '../../../../imgs/icon-alarm@2x.png';
import transformerPng from '../../../../imgs/transformer.png';
import switchOnPng from '../../../../imgs/switch-on.png';
import switchOffPng from '../../../../imgs/switch-off.png';
import { AreaItem } from './index';
import { isNil } from 'lodash-es';
import {
  V2ElectricMapDataGgdDataPostResponse,
  V2ElectricMapDataScalePostResponse,
} from '@maxtropy/device-customer-apis-v2';
import { StationItem } from './index';
import bg_childStation from '../../../../imgs/bg-childStation.png';

const baseUrl = getAssetBaseUrl();

export const mapExtensionModule = () => {
  let mapInstance: any = null;
  let mapType = 'shijing-3d';
  let isInit = false;

  const setMapBackgroundMode = (mode: 'light' | 'black' | 'none') => {
    switch (mode) {
      case 'light':
        mapInstance.tb.scene.background = mapInstance.tb.sceneSkyTexture;
        mapInstance.tb.scene.fog = mapInstance.tb.defaultFog;
        break;

      case 'black':
        mapInstance.tb.scene.background = mapInstance.tb.sceneNightTexture;
        mapInstance.tb.scene.fog = null;
        break;

      case 'none':
        mapInstance.tb.scene.background = null;
        mapInstance.tb.scene.fog = null;
    }
  };

  const setMapType = async (type: string) => {
    const oldMapType = mapType;
    if (oldMapType === type || !mapInstance) return;
    mapType = type;
    mapInstance._mapType = type;

    if (!isInit) {
      processLayers(mapInstance, (id, layer, isThreeBoxLayer) => {
        if (!isThreeBoxLayer && !['satellite'].includes(id)) {
          layer._originVisible = mapInstance.getLayoutProperty(id, 'visibility') || 'visible';
        }
      });

      if (!mapInstance.getLayer('default_scene')) {
        mapInstance._createSceneLayer();
        mapInstance._baseLayers.push('default_scene');
      }
    }

    switch (type) {
      case '2d':
        setMapBackgroundMode('none');
        processLayers(mapInstance, (id, layer, isThreeBoxLayer) => {
          console.log('mapInstance', mapInstance);
          if (!isThreeBoxLayer) {
            if (id === 'satellite') {
              mapInstance.setLayoutProperty(id, 'visibility', 'none');
            } else {
              mapInstance.setLayoutProperty(id, 'visibility', layer._originVisible);
            }
          } else if (id === 'default_scene') {
            mapInstance.setLayoutProperty(id, 'visibility', 'none');
          }
        });
        break;

      case 'satellite':
        setMapBackgroundMode('none');
        processLayers(mapInstance, (id, layer, isThreeBoxLayer) => {
          if (!isThreeBoxLayer) {
            const visibility =
              id === 'satellite' ? 'visible' : ['satellite', 'background'].includes(id) ? layer._originVisible : 'none';
            mapInstance.setLayoutProperty(id, 'visibility', visibility);
          } else if (id === 'default_scene') {
            mapInstance.setLayoutProperty(id, 'visibility', 'none');
          }
        });
        break;

      case '3d':
        if (!mapInstance.getLayer('default_model')) {
          await mapInstance._createModelLayer();
          mapInstance._baseLayers.push('default_model');
        }

        // 设置背景
        setMapBackgroundMode('light');

        if (oldMapType != '3d-keji') {
          createDefaultLight();
          processLayers(mapInstance, (id, layer, isThreeBoxLayer) => {
            if (isThreeBoxLayer) {
              mapInstance.setLayoutProperty(
                id,
                'visibility',
                id === 'default_scene' || id === 'default_model' ? 'visible' : 'none'
              );
            } else {
              mapInstance.setLayoutProperty(id, 'visibility', 'none');
            }
          });
        }
        mapInstance.set3dStyle('shijing');
        break;

      case '3d-keji':
        if (!mapInstance.getLayer('default_model')) {
          mapInstance._3dStyle = 'keji';
          await mapInstance._createModelLayer();
          mapInstance._baseLayers.push('default_model');
        }

        // 设置背景
        setMapBackgroundMode('black');

        if (oldMapType != '3d') {
          mapInstance._3dStyle = undefined;
          createDefaultLight();
          processLayers(mapInstance, (id, layer, isThreeBoxLayer) => {
            if (isThreeBoxLayer) {
              mapInstance.setLayoutProperty(
                id,
                'visibility',
                id === 'default_scene' || id === 'default_model' ? 'visible' : 'none'
              );
            } else {
              mapInstance.setLayoutProperty(id, 'visibility', 'none');
            }
          });
        }

        mapInstance.set3dStyle('keji');

        break;

      case '3d-dark':
        if (!mapInstance.getLayer('base-layer-3d-dark')) {
          createDarkModelLayer();
          mapInstance._baseLayers.push('base-layer-3d-dark');
        } else {
          const water = mapInstance.tb.scene.getObjectByName('water');
          if (water) water.visible = true;
        }

        // 设置背景
        setMapBackgroundMode('light');

        create3dDarkLight();
        processLayers(mapInstance, (id, layer, isThreeBoxLayer) => {
          if (isThreeBoxLayer) {
            mapInstance.setLayoutProperty(
              id,
              'visibility',
              id === 'default_scene' || id === 'base-layer-3d-dark' ? 'visible' : 'none'
            );
          } else {
            mapInstance.setLayoutProperty(id, 'visibility', 'none');
          }
        });
        break;
    }

    mapInstance.fire('maptypechange');
    mapInstance.fire('map-type-change', { mapType: mapInstance._mapType });
    if (!isInit) {
      mapInstance.fire('map-init');
      isInit = true;
    }
  };

  const create3dDarkLight = () => {
    const oldLightGroup = mapInstance.tb.scene.getObjectByName('base-layer-lights');
    if (oldLightGroup) mapInstance.tb.scene.remove(oldLightGroup);

    const group = new kkmapgl.THREE.Group();
    group.name = 'base-layer-lights';
    const worldUnitPerMeter = mapInstance.tb.projectedUnitsPerMeter(31.344352);

    const ambientLight = new kkmapgl.THREE.AmbientLight(
      new kkmapgl.THREE.Color().setStyle('#8c8c8c', kkmapgl.THREE.LinearSRGBColorSpace),
      Math.PI
    );
    ambientLight.name = 'ambient_light';
    group.add(ambientLight);

    // 创建平行光
    const dirLight = new kkmapgl.THREE.DirectionalLight(0xffffff, 5.5 * Math.PI, 200, 1);
    dirLight.name = 'dir_light';
    dirLight.castShadow = true; // 投射阴影
    const vector = new kkmapgl.THREE.Vector3(
      -200 * worldUnitPerMeter,
      100 * worldUnitPerMeter,
      150 * worldUnitPerMeter
    ); // 初始向量
    const quaternion = new kkmapgl.THREE.Quaternion().setFromAxisAngle(
      new kkmapgl.THREE.Vector3(0, 0, 1),
      kkmapgl.THREE.MathUtils.degToRad(-28.5)
    ); // 创建一个四元数
    vector.applyQuaternion(quaternion); // 应用四元数旋转
    dirLight.position.set(vector.x, vector.y, vector.z);
    dirLight.target.position.set(0, 0, 0);
    dirLight.shadow.mapSize.width = 1024 * 8;
    dirLight.shadow.mapSize.height = 1024 * 8;
    dirLight.shadow.camera.near = -2048;
    dirLight.shadow.camera.far = 2048;
    dirLight.shadow.camera.left = -2048;
    dirLight.shadow.camera.right = 2048;
    dirLight.shadow.camera.top = 2048;
    dirLight.shadow.camera.bottom = -2048;
    dirLight.shadow.radius = 12;
    group.add(dirLight);

    group.updateMatrixWorld();

    mapInstance.tb.scene.add(group);
  };

  const createDefaultLight = () => {
    const oldLightGroup = mapInstance.tb.scene.getObjectByName('base-layer-lights');
    if (oldLightGroup) mapInstance.tb.scene.remove(oldLightGroup);

    // 创建一个名为default_lights的组
    const group = new kkmapgl.THREE.Group();
    group.name = 'base-layer-lights';
    const worldUnitPerMeter = mapInstance.tb.projectedUnitsPerMeter(31.344352);

    // 创建环境光
    const ambientLight = new kkmapgl.THREE.AmbientLight(
      new kkmapgl.THREE.Color().setStyle('#ffffff', kkmapgl.THREE.LinearSRGBColorSpace),
      2.4 * Math.PI
    );
    ambientLight.name = 'ambient_light';
    group.add(ambientLight);

    // 创建平行光
    const dirLight = new kkmapgl.THREE.DirectionalLight(
      new kkmapgl.THREE.Color().setStyle('#ffffff', kkmapgl.THREE.LinearSRGBColorSpace),
      1.6 * Math.PI
    );
    dirLight.name = 'dir_light';
    dirLight.castShadow = true; // 投射阴影
    const vector = new kkmapgl.THREE.Vector3(
      -200 * worldUnitPerMeter,
      -100 * worldUnitPerMeter,
      150 * worldUnitPerMeter
    ); // 初始向量
    const quaternion = new kkmapgl.THREE.Quaternion().setFromAxisAngle(
      new kkmapgl.THREE.Vector3(0, 0, 1),
      kkmapgl.THREE.MathUtils.degToRad(-28.5)
    ); // 创建一个四元数
    vector.applyQuaternion(quaternion); // 应用四元数旋转
    dirLight.position.set(vector.x, vector.y, vector.z);
    dirLight.target.position.set(0, 0, 0);
    dirLight.shadow.mapSize.width = 1024 * 8;
    dirLight.shadow.mapSize.height = 1024 * 8;
    dirLight.shadow.camera.near = -2048;
    dirLight.shadow.camera.far = 2048;
    dirLight.shadow.camera.left = -2048;
    dirLight.shadow.camera.right = 2048;
    dirLight.shadow.camera.top = 2048;
    dirLight.shadow.camera.bottom = -2048;
    dirLight.shadow.radius = 12;
    group.add(dirLight);

    // 更新物体及其后代的全局变换
    group.updateMatrixWorld();
    mapInstance.tb.scene.add(group);
  };

  const createDarkModelLayer = () => {
    const layerId = 'base-layer-3d-dark';

    mapInstance.addLayer({
      id: layerId,
      type: 'model',
      models: [
        {
          type: 'glb',
          url: baseUrl + '/models/091501.glb',
          draco: true,
          ktx2Parse: true,
          useMeshOpt: true,
        },
      ],
      units: 'centimeters',
      lnglat: [121.63523, 31.34435, -4.5],
      showLoading: true,
      callback: (group, layer) => {
        group.setRotation({ x: 0, y: 0, z: -28.5 });
        group.setScale({ x: 1000, y: 1000, z: 1000 });

        group.traverse(child => {
          if (!child.isMesh) {
            child.castShadow = true;
            child.receiveShadow = true;

            return;
          } else if (child.name !== 'shu') {
            child.castShadow = true;
            child.receiveShadow = true;
          }

          const name = child.name || '';
          if (name.includes('shui')) {
            const water = mapInstance.tb.scene.getObjectByName('water');
            if (water) {
              water.visible = true;
              return;
            } else {
              const worldUnits = mapInstance.tb.getWolrdUnitFromMesh(child);
              const points = worldUnits.map(vector3 => vector3.clone().sub(worldUnits[0]));
              const geometry = child.geometry.clone();
              geometry.setFromPoints(points);
              const lngLats = layer._map.tb.unprojectFromWorld(worldUnits[0]);

              layer.addDynamicWater({
                id: 'water',
                textureWidth: 512,
                waterNormals: WaterNormals,
                // alpha: 0.75,
                // sunDirection: layer._map.tb.scene
                //   .getObjectByName('dir_light')
                //   .position.clone()
                //   .normalize(),
                // sunColor: 0xffffff,
                waterColor: 0x001e0f,
                distortionScale: 100,
                size: 1,
                geometry: geometry,
                lngLats: [[lngLats[0], lngLats[1], -4.2]],
              });
            }
          }
        });
      },
    });
  };

  return {
    setMapInstance: (instance: any) => {
      instance.setMapType = setMapType;
      mapInstance = instance;
    },
    setMapType,
  };
};

const processLayers = (map: any, handler: (id: string, layer: any, isThreeBoxLayer: boolean) => void) => {
  if (!map || !handler) return;

  const baseLayers = map._baseLayers;
  for (const id of baseLayers) {
    const layer = map.style._layers[id];
    if (!layer) continue;

    const isThreeBoxLayer = layer.implementation?.isThreeBoxLayer;
    handler(id, layer, isThreeBoxLayer);
  }
};

export function createDom(area: AreaItem, isSelected?: boolean): string {
  const isStationMarker = !isNil(area.roomId);

  const outerBgColor = isSelected
    ? 'rgba(133,116,26,0.8)'
    : isStationMarker
    ? 'rgba(4,83,52,0.8)'
    : 'rgba(44,26,133,0.8)';

  const outerBorder = isSelected ? '1px solid #DDC016' : isStationMarker ? '1px solid #16DD8E' : '1px solid #167CDD';

  const alarmIconHtml = area.flag
    ? `<img id="marker-alarm-${area.id}" src="${alarmPng}" style="width:28px;height:28px;margin-left:4px;object-fit:contain;" />`
    : '';

  const backgroundImage = isStationMarker ? markerPng : areaMarkerPng;

  return `
    <div style="display:flex;flex-direction:column;justify-content:center;align-items:center;cursor:pointer;">
      <div id="marker-outer-${area.id}" style="
        position:relative;
        border-radius:2px;
        background-color:${outerBgColor};
        padding:4px 8px;
        box-shadow:0px 8px 16px 0px rgba(0,0,0,0.3);
        box-sizing:border-box;
        border:${outerBorder};
        display:flex;
        flex-direction:row;
        justify-content:space-between;
        align-items:center;
        width:188px;
      ">
        <div style="flex:1;text-align:center">
          <div style="color:#52E7FF;font-size:14px;font-weight:500;">实时功率</div>
          <div style="color:#FFF;font-size:14px;font-weight:500;">
            ${keepZeroOrLine(area.power)}kW
          </div>
        </div>
        <div style="height:31px;width:1px;background-color:rgba(255,255,255,0.2);margin:0 4px;"></div>
        <div style="flex:1;text-align:center">
          <div style="color:#52E7FF;font-size:14px;font-weight:500;">本月用电</div>
          <div style="color:#FFF;font-size:14px;font-weight:500;">
            ${keepZeroOrLine(area.electricity)}kWh
          </div>
        </div>
        ${alarmIconHtml}
      </div>
      <div id="marker-icon-${area.id}" style="
        width:25px;
        height:28px;
        background-image:url(${backgroundImage});
        background-repeat:no-repeat;
        background-size:100% 100%;
        background-position:center 0;
        margin:0;
        z-index:-999;
      "></div>
    </div>
  `;
}

export function changeDom(area: AreaItem, target: any, isSelected?: boolean) {
  const isStationMarker = !isNil(area.roomId);
  const outerBorder = isSelected ? '1px solid #DDC016' : isStationMarker ? '1px solid #16DD8E' : '1px solid #167CDD';

  const outerBgColor = isSelected
    ? 'rgba(133,116,26,0.8)'
    : isStationMarker
    ? 'rgba(4,83,52,0.8)'
    : 'rgba(44,26,133,0.8)';
  if (target) {
    target.style.background = outerBgColor;
    target.style.border = outerBorder;
  }
}

export function createPstationDom(station: StationItem, scaleData?: V2ElectricMapDataScalePostResponse) {
  const itemValue = `font-weight: 500;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.85);
    flex: 1;
    text-align: right;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;`;

  const itemLabel = `flex-shrink: 0;
          font-weight: 400;
          font-size: 12px;
          color: rgba(255, 255, 255, 0.65);`;

  const imgWrapper = `display: flex;
        align-items: center;
        justify-content: center;
        column-gap: 4px;`;

  // 因为渲染tooltip，所以column-reverse，不能影响下钻位置
  return `
  <div style="display:flex;flex-direction:column-reverse;align-items: center;height: 260px;">
   <div id="marker-pStation-icon-${station.id}" style="
      width:24px;
      height:28px;
      background-image:url(${areaMarkerPng});
      background-repeat:no-repeat;
      background-size:100% 100%;
      background-position:center 0;
      margin-top:3px;
      z-index:-999;
    "></div>
    <div style="
        background: rgba(4, 13, 24, 0.6);
        border-radius: 4px;
        height: 122px;
        min-width: 220px;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        background-image: url(${center_card_bg});
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center;
      ">
        <div style="
          display: flex;
          align-items: center;
          padding: 7px 11px;
        ">
        <div style="
          font-weight: 500;
          font-size: 14px;
          color: rgba(255, 255, 255, 0.65);
        ">${station.name}</div>
        <img id="icon-cap-${
          station.roomId
        }" src="${icon_cap}" style="width:16px;height:16px;margin-left:4px;object-fit:contain;"/>
        </div>
        <div style="width: 80%;height:1px;background-color:rgba(255,255,255,0.2);display:flex;margin-left:10%;margin-bottom:12px" ></div>
        <div style="
          font-weight: 400;
          font-size: 14px;
          color: rgba(255, 255, 255, 0.65);
        ">实时总功率(kW)</div>
        <div style="
          font-family: YouSheBiaoTiHei;
          font-size: 36px;
          color: #ffffff;
        ">${keepZeroOrLine(station.power)}</div>
      </div>
   
      <div id="tooltip-${station.roomId}" style="background: #3E3E3E;
        display:none !important;
        border-radius: 4px;
        padding: 8px 8px;
        height: 78px;
        min-width: 150px;
        align-self: center;">
        <div style="${imgWrapper}">
          <img style="width: 12px;height: 12px;" src="${IconCapacityPng}" alt="" />
          <div style="${itemLabel}">总容量</div>
          <div style="${itemValue}">${keepZeroOrLine(scaleData?.totalInstalledCapacity)}kVA</div>
        </div>
        <div style="${imgWrapper}">
          <img style="width: 12px;height: 12px;" src="${IconMonitorPng}" alt="" />
          <div style="${itemLabel}">监测线路</div>
          <div style="${itemValue}">${scaleData?.circuitCount ?? '--'}</div>
        </div>
        <div style="${imgWrapper}">
          <img style="width: 12px;height: 12px;" src="${IconStationPng}" alt="" />
          <div style="${itemLabel}">站房</div>
          <div style="${itemValue}">${scaleData?.roomCount ?? '--'}</div>
        </div>
      </div>
    
    </div>
  `;
}

// 创建配电站
export function createChildrenStationDom(item?: StationItem) {
  return `
  <div style="display:flex; flex-direction: column;align-items: center;height: 64px;">
    <div style="
        background: rgba(4, 13, 24, 0.6);
        border-radius: 4px;
        height: 34px;
        width: 100%;
        padding: 7px 9px;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center;
        display: flex;
        align-items: center;
        text-align: center;
        background-image: url(${bg_childStation});
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center;
      ">
        <div style="
          font-weight: 500;
          font-size: 14px;
          color: rgba(255, 255, 255, 0.65);
        ">${item?.name}</div>
      </div>
      <div id="marker-pStation-icon-${item?.roomId}" style="
        width:24px;
        height:28px;
        background-image:url(${areaMarkerPng});
        background-repeat:no-repeat;
        background-size:100% 100%;
        background-position:center 0;
        margin-top:2px;
        z-index:-999;
      "></div>
    </div>
  `;
}

export function getPopupHtml(resLeft: any, resRight: any, name: string) {
  return `<div style="width:880px;height:280px;padding:12px 16px;">
        <div style="display: flex">
          <div
            style="
              flex: 1;
              font-weight: 500;
              font-size: 16px;
              color: rgba(255, 255, 255, 0.85);
            "
          >
            ${name ?? '--'}
          </div>
          <button  id="viewMoreBtn" type="button" style="padding: 0px;background-color: transparent;border: none;display: flex;justify-content: center;align-items: center;cursor: pointer;margin-right: 8px;">
            <div style="color:#4A90E2;font-size: 14px">更多</div>
            <svg viewBox="64 64 896 896" focusable="false" data-icon="double-right" width="14px" height="14px" fill="#4A90E2" aria-hidden="true"><path d="M533.2 492.3L277.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H188c-6.7 0-10.4 7.7-6.3 12.9L447.1 512 181.7 851.1A7.98 7.98 0 00188 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5zm304 0L581.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H492c-6.7 0-10.4 7.7-6.3 12.9L751.1 512 485.7 851.1A7.98 7.98 0 00492 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z"></path></svg>
          </button>
          <button
            id="closePopupBtn"
            type="button"
            style="
              background-color: transparent;
              cursor: pointer;
              border: none;
              display: flex;
              justify-content: center;
              align-items: center;
            "
          >
          <div style="cursor:pointer;color:rgba(255,255,255,0.6);font-size:16px;">✕</div>
        </button>
        </div>
        <div style="display: flex; padding-top: 16px">
          <div style="width: 260px">
            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 6px;
              "
            >
              <div style="color: rgba(255, 255, 255, 0.85); line-height: 24px">
                <div style="line-height: 24px;">
                  今日用电（kWh）
                </div>
                <div
                  style="
                    display: inline-block;
                    font-family: YouSheBiaoTiHei;
                    line-height: 24px;
                    font-size: 18px;
                    font-style: normal;
                    background: linear-gradient(
                      180deg,
                      #00aeff 0%,
                      #65ffe9 39%,
                      #00d4ff 100%
                    );
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                  "
                >
                  ${keepTwoOrLine(resLeft.electricity)}
                </div>
              </div>
              <div style="color: rgba(255, 255, 255, 0.85); line-height: 24px">
                <div>日环比</div>
                <div style="display: flex; align-items: center;">
                ${getRateHtml(resLeft?.rate)}
                </div>
              </div>
            </div>
            <div id="popupLineChart" style="width: 266px; height: 140px"></div>
          </div>
          <div
            style="
              height: 200px;
              width: 1px;
              background-color: rgba(255, 255, 255, 0.2);
              margin: 0 12px;
            "
          ></div>
          <div style="flex: 1">
            <div id="popupPieChart" style="width: 100%; height: 220px"></div>
          </div>
        </div>
      </div>`;
}

export const getRateHtml = (rate?: number) => {
  const value = rate ? Math.abs(rate) : null;
  const isUp = (rate ?? 0) > 0;

  if (isNil(rate)) return `<div style="color: rgba(255,255,255,0.85); margin-right: 2px;">--%</div>`;
  return `<div style="color: ${isUp ? '#FF4D4F' : '#59D744'};margin-right: 2px;">${
    rate ? keepPercentOrLine(value) : '--'
  }%</div>
  <div style="color: #FF4D4F;padding-top:2px; display: ${(rate ?? 0) > 0 ? 'block' : 'none'}">
    <svg viewBox="64 64 896 896" focusable="false" data-icon="arrow-up" width="12px" height="12px" fill="currentColor" aria-hidden="true"><path d="M868 545.5L536.1 163a31.96 31.96 0 00-48.3 0L156 545.5a7.97 7.97 0 006 13.2h81c4.6 0 9-2 12.1-5.5L474 300.9V864c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V300.9l218.9 252.3c3 3.5 7.4 5.5 12.1 5.5h81c6.8 0 10.5-8 6-13.2z"></path></svg>
  </div>
  <div style="color: #59D744;padding-top:2px; display: ${(rate ?? 0) <= 0 ? 'block' : 'none'}">
    <svg viewBox="64 64 896 896" focusable="false" data-icon="arrow-down" width="12px" height="12px" fill="currentColor" aria-hidden="true"><path d="M862 465.3h-81c-4.6 0-9 2-12.1 5.5L550 723.1V160c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v563.1L255.1 470.8c-3-3.5-7.4-5.5-12.1-5.5h-81c-6.8 0-10.5 8.1-6 13.2L487.9 861a31.96 31.96 0 0048.3 0L868 478.5c4.5-5.2.8-13.2-6-13.2z"></path></svg>
  </div>`;
};

export const getCircleRateHtml = (value: number, color: string, percentColor: string) => {
  const percent = Math.max(0, Math.min(100, Number(value ?? 0) * 100)); // 限制在 0-100
  const dashoffset = (100 - percent).toFixed(1);

  return `
    <div style="display:flex;align-items:center;justify-content: space-between;gap:4px;
                background: rgba(74,144,226,0.2);
                border-radius: 2px;flex:1;
                padding:0 8px;line-height: 24px;">
      <span style="color: ${percentColor};">${keepPercentOrLine(value)}%</span>
      <svg width="16" height="16" viewBox="0 0 36 36">
        <circle cx="18" cy="18" r="16"
                stroke="rgba(74,144,226,0.2)" stroke-width="4" fill="none" />
        <circle cx="18" cy="18" r="16"
                stroke=${color} stroke-width="4" fill="none"
                stroke-dasharray="100,100"
                stroke-dashoffset="${dashoffset}"
                transform="rotate(-90 18 18)" />
      </svg>
    </div>
  `;
};

export function getStationPopupHtml(list: any[], name: string, flag: boolean) {
  const itemsHtml = list
    .map(item => {
      return `
    <div style="width: 100%;background-color: #111D2C;border-radius: 2px;padding: 12px 8px;border: 1px solid rgba(255,255,255,0.2);margin-top: 8px;">
      <div style="display:flex;row-gap: 4px;">
        <div style="display:flex;align-items:center;column-gap: 4px;flex:1;">
          <img style="width: 24px;height: 24px;" src="${transformerPng}" />
          <div style="font-size: 16px;color:rgba(255,255,255,0.85);">${item.name ?? ''}</div>
        </div>
        <div style="width: 270px;display:flex;flex-direction: column;row-gap: 4px;">
          <div style="display:flex;column-gap: 8px;">
            <div style="font-size: 12px;color:rgba(255,255,255,0.65);flex:1;">峰值功率</div>
            <div style="font-size: 12px;color:rgba(255,255,255,0.65);flex:1;">平均功率</div>
          </div>
          <div style="display:flex;column-gap: 8px;">
            <div style="background: rgba(74,144,226,0.2);border-radius: 2px;flex:1;padding-left: 8px;line-height: 24px;">${keepTwoOrLine(
              item.summitPower
            )}kW</div>
            <div style="background: rgba(74,144,226,0.2);border-radius: 2px;flex:1;padding-left: 8px;line-height: 24px;">${keepTwoOrLine(
              item.avgPower
            )}kW</div>
          </div>
          <div style="display:flex;column-gap: 8px;">
            <div style="font-size: 12px;color:rgba(255,255,255,0.65);flex:1;display:flex;align-items: center;">
              <div>环比上月：</div>
              ${getRateHtml(item.summitPowerRate)}
            </div>
            <div style="font-size: 12px;color:rgba(255,255,255,0.65);flex:1;display:flex;align-items: center;">
              <div>环比上月：</div>
              ${getRateHtml(item.avgPowerRate)}
            </div>
          </div>
          <div style="font-size: 12px;color:rgba(255,255,255,0.65);line-height: 20px;padding-left: 8px;background-color: rgba(255,255,255,0.1);border-radius: 2px;">
            峰值时间：${item.time ?? ''}
          </div>
        </div>
        <div style="border-left: 1px dashed rgba(255,255,255,0.2);height: 100%;margin: 0 8px;"></div>
        <div style="width: 270px;display:flex;flex-direction: column;row-gap: 4px;">
          <div style="display:flex;column-gap: 8px;">
            <div style="font-size: 12px;color:rgba(255,255,255,0.65);flex:1;">峰值负载率</div>
            <div style="font-size: 12px;color:rgba(255,255,255,0.65);flex:1;">平均负载率</div>
          </div>
          <div style="display:flex;column-gap: 8px;">
            ${getCircleRateHtml(item.summitLoad ?? 0, '#FFCB47', '#FFCB47')}
            ${getCircleRateHtml(item.avgLoad ?? 0, '#5BFF60', '#FFFFFF')}
          </div>
          <div style="display:flex;column-gap: 8px;">
            <div style="font-size: 12px;color:rgba(255,255,255,0.65);flex:1;display:flex;align-items: center;">
              <div>环比上月：</div>
              ${getRateHtml(item.summitLoadRate)}
            </div>
            <div style="font-size: 12px;color:rgba(255,255,255,0.65);flex:1;display:flex;align-items: center;">
              <div>环比上月：</div>
              ${getRateHtml(item.avgLoadRate)}
            </div>
          </div>
          <div style="font-size: 12px;color:rgba(255,255,255,0.65);line-height: 20px;padding-left: 8px;background-color: rgba(255,255,255,0.1);border-radius: 2px;">
            峰值时间：${item.time ?? ''}
          </div>
        </div>
      </div>
    </div>
  `;
    })
    .join('');
  return `<div style="width: 720px;max-height: 480px;padding:12px 16px;overflow:auto;">
            <div style="display:flex;margin-bottom: 12px;justify-content:space-between;align-items:center;">
              <div style="display: flex;align-items: center;flex:1;">
                <div style="font-weight: 500;font-size: 16px;color:rgba(255,255,255,0.85);">${name ?? '--'}</div>
                  ${flag ? `<img src="${alarmPng}" style="width: 28px;height: 28px;margin-left: 8px;"/>` : ''} 
              </div>
              <button  id="viewMoreBtn" type="button" style="padding: 0px;background-color: transparent;border: none;display: flex;justify-content: center;align-items: center;cursor: pointer;margin-right: 8px;">
                <div style="color:#4A90E2;font-size: 14px">查看站房详情</div>
                <svg viewBox="64 64 896 896" focusable="false" data-icon="double-right" width="14px" height="14px" fill="#4A90E2" aria-hidden="true"><path d="M533.2 492.3L277.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H188c-6.7 0-10.4 7.7-6.3 12.9L447.1 512 181.7 851.1A7.98 7.98 0 00188 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5zm304 0L581.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H492c-6.7 0-10.4 7.7-6.3 12.9L751.1 512 485.7 851.1A7.98 7.98 0 00492 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z"></path></svg>
              </button>
              <button
                id="closePopupBtn"
                type="button"
                style="
                  background-color: transparent;
                  cursor: pointer;
                  border: none;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
              >
                <div style="cursor:pointer;color:rgba(255,255,255,0.6);font-size:16px;">✕</div>
              </button>

            </div>
            ${itemsHtml}
          </div>`;
}

export function createLightPopupHtml(data: V2ElectricMapDataGgdDataPostResponse) {
  return `
   <div style="
  width:320px;
  height:208px;
  background:linear-gradient(180deg,#041b33 0%,#001c37 100%);
  box-shadow:0px 12px 48px 16px rgba(0,0,0,0.12),
             0px 9px 28px 0px rgba(0,0,0,0.2),
             0px 6px 16px -8px rgba(0,0,0,0.32);
  border-radius:2px;
  border:1px solid rgba(74,144,226,0.5);
  padding:12px 16px;
  position:relative;
  z-index:20;
  font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial;
">
  <div style="display:flex;justify-content:space-between;align-items:center;gap:16px;">
    <div style="font-weight:500;font-size:16px;color:rgba(255,255,255,0.85);flex:1;">
      ${data?.name ?? '--'}
    </div>
    <div id="moreLink" style="color:#4A90E2;cursor: pointer;">更多</div>
    <button
      id="closePopupBtn"
      type="button"
      style="
        background-color: transparent;
        cursor: pointer;
        border: none;
        display: flex;
        justify-content: center;
        align-items: center;
      "
    >
      <div style="cursor:pointer;color:rgba(255,255,255,0.6);font-size:16px;">✕</div>
    </button>
  </div>

  <div style="display:flex;column-gap:34px;align-items:center;margin-top:16px;">
    <div style="display:flex;align-items:center;">
      <div style="font-weight:400;font-size:14px;color:rgba(255,255,255,0.85);margin-top:0;">状态：</div>
      ${
        data.intStatus === 2
          ? '<span style="font-size:14px;color:rgba(255,255,255,0.6);">离线</span>'
          : `<img id="status-switch" style="width: 44px;height: 22px;cursor:pointer;" src="${
              data.intStatus === 1 ? switchOnPng : switchOffPng
            }" />`
      }
    </div>

    <div style="font-weight:400;font-size:14px;color:rgba(255,255,255,0.85);margin-top:0;">
      功率：
      <span style="
        font-family:YouSheBiaoTiHei;
        font-size:18px;
        background:linear-gradient(180deg,#00aeff 0%,#65ffe9 39%,#00d4ff 100%);
        -webkit-background-clip:text;
        -webkit-text-fill-color:transparent;
      ">${keepTwoOrLine(data.power)}kW</span>
    </div>
  </div>

  <div style="font-weight:400;font-size:14px;color:rgba(255,255,255,0.85);margin-top:16px;">
    温度：<span style="font-weight:500;font-size:14px;color:#ffffff;">${data.temperature ?? '--'}℃</span>
  </div>

  <div style="font-weight:400;font-size:14px;color:rgba(255,255,255,0.85);margin-top:16px;">
    A/B/C三相电压：
    <span style="color:#FFC53D;">${keepZeroOrLine(data.avoltage)}</span>
    <span style="color:#FFF;">/</span>
    <span style="color:#52C41A;">${keepZeroOrLine(data.bvoltage)}</span>
    <span style="color:#FFF;">/</span>
    <span style="color:#E64242;">${keepZeroOrLine(data.cvoltage)}</span>
    <span style="color:#FFF;margin-left:4px;">V</span>
  </div>

  <div style="font-weight:400;font-size:14px;color:rgba(255,255,255,0.85);margin-top:16px;">
    A/B/C三相电流：
    <span style="color:#FFC53D;">${keepZeroOrLine(data.acurrent)}</span>
    <span style="color:#FFF;">/</span>
    <span style="color:#52C41A;">${keepZeroOrLine(data.bcurrent)}</span>
    <span style="color:#FFF;">/</span>
    <span style="color:#E64242;">${keepZeroOrLine(data.ccurrent)}</span>
    <span style="color:#FFF;margin-left:4px;">A</span>
  </div>
</div>
  `;
}

export const loadImageAsync = (map: any, name: string, url: string) => {
  return new Promise<void>((resolve, reject) => {
    if (map.hasImage(name)) return resolve();
    map.loadImage(url, (error: any, image: any) => {
      if (error) return reject(error);
      if (!map.hasImage(name)) map.addImage(name, image);
      resolve();
    });
  });
};

export function createPulsingDot(size: number, color: string) {
  return {
    width: size,
    height: size,
    data: new Uint8ClampedArray(size * size * 4),
    canvas: undefined as HTMLCanvasElement | undefined,
    context: undefined as CanvasRenderingContext2D | null | undefined,

    onAdd() {
      this.canvas = document.createElement('canvas');
      this.canvas.width = this.width;
      this.canvas.height = this.height;
      this.context = this.canvas.getContext('2d');
    },

    onRemove() {
      this.context?.clearRect(0, 0, this.width, this.height);
      this.canvas = undefined;
    },

    render() {
      const ctx = this.context;
      if (!ctx) return false;
      const t = (performance.now() % 1000) / 1000;
      const radius = this.width / 4;
      const outerRadius = radius + (this.width / 2 - radius) * t;

      ctx.clearRect(0, 0, this.width, this.height);
      ctx.beginPath();
      ctx.arc(this.width / 2, this.height / 2, outerRadius, 0, Math.PI * 2);
      ctx.fillStyle = `rgba(${color},${1 - t})`;
      ctx.fill();

      ctx.beginPath();
      ctx.arc(this.width / 2, this.height / 2, radius, 0, Math.PI * 2);
      ctx.fillStyle = `rgba(${color},1)`;
      ctx.fill();

      this.data = ctx.getImageData(0, 0, this.width, this.height).data as any;
      map.triggerRepaint();
      return true;
    },
  };
}
